import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { ThesisDefenseRequestAction } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";

const RequestDialog = ({ id, action }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const actionText = action === ThesisDefenseRequestAction.Approve ? "Одобряване" : "Отказ";
  const title = action === ThesisDefenseRequestAction.Approve ? "одобрите" : "откажете";
  const icon = action === ThesisDefenseRequestAction.Approve ? <ThumbUpAltIcon /> : <ThumbDownAltIcon />;
  const color = action === ThesisDefenseRequestAction.Approve ? "success" : "error";

  const handleSubmit = async () => {
    await dataProvider.customRequest(graduationRequests.thesisDefenseRequestAction(id, action), null, "PUT");
    refresh();
    notify(`Успешно ${action} на заявка за защита на преддипломна работа`, { type: "success" });
  };

  return (
    <ConfirmModal
      titleContent={`${actionText} заявка за защита на преддипломна работа`}
      onConfirm={handleSubmit}
      message={`Сигурни ли сте, че искате да ${title} заявката за защита на преддипломна работа?`}
      triggerButton={
        <Button
          label={action === ThesisDefenseRequestAction.Approve ? "Одобри заявка" : "Откажи заявка"}
          color={color}
          startIcon={icon}
        />
      }
    />
  );
};

export default RequestDialog;
